import { InjectionToken } from '@angular/core';

import type {
	AuthRepository,
	EmailOtpRepository,
	PasskeyRepository,
	TotpRepository
} from '@contexts/auth/domain';

export const AUTH_REPOSITORY = new InjectionToken<AuthRepository>('AuthRepository');
export const TOTP_REPOSITORY = new InjectionToken<TotpRepository>('TotpRepository');
export const EMAIL_OTP_REPOSITORY = new InjectionToken<EmailOtpRepository>('EmailOtpRepository');
export const PASSKEY_REPOSITORY = new InjectionToken<PasskeyRepository>('PasskeyRepository');
